import { RetryContext, IRetryPolicy } from '@microsoft/signalr';

export class ReconnectPolicy implements IRetryPolicy {
    public nextRetryDelayInMilliseconds(retryContext: RetryContext): number | null {
        // Stop trying after 10 attempts (approximately 2 minutes of retrying)
        if (retryContext.previousRetryCount >= 10) {
            return null;
        }

        // Exponential backoff: 0s, 2s, 4s, 8s, 16s, 30s, 30s, 30s, 30s, 30s
        const delays = [0, 2000, 4000, 8000, 16000, 30000, 30000, 30000, 30000, 30000];
        return delays[retryContext.previousRetryCount] || 30000;
    }
}
